/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { navigate } from 'gatsby';
import { UtilityCard } from '@vfuk/core-utility-card';
import {
  FeatureCardWrapper,
  Label,
} from './styles/FeatureCardsWithIcon.styles';
import { FeatureCardsWithIconProps } from './types/FeatureCardsWithIcon.types';

const FeatureCardsWithIcon = ({
  card,
  onCardClick,
}: FeatureCardsWithIconProps) => {
  const { header, bodyText, urlLink, iconRef, label } = card;

  const handleCardClick = () => {
    if (urlLink) {
      onCardClick ? onCardClick(urlLink) : navigate(`${urlLink}`);
    }
  };

  return (
    <FeatureCardWrapper onClick={handleCardClick} isClickable={!!urlLink}>
      <>
        {label && (
          <Label>
            <span>{label}</span>
          </Label>
        )}
        <UtilityCard
          heading={{ text: header }}
          text={bodyText.bodyText}
          icon={{ name: iconRef }}
          elevation
        />
      </>
    </FeatureCardWrapper>
  );
};

export default FeatureCardsWithIcon;
